const DocumentIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected
    ? 'var(--forbrand-primary)'
    : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 11V3.5H10.5L9 1.5H3.5V3.5H1V15H10.8358L11.5 14H2L2.0033 6.49224H3.50134L3.5 13H14.3643L15 12H4.5L4.50134 4.50299L14 4.5V11H15ZM3.50134 5.49224H2.0033V4.50299H3.50134V5.49224ZM4.5 3.5V2.5H8.62991L9.37106 3.5H4.5Z"
          fill={fillColor}
        />
        <path d="M13 8H5.5V9H13V8Z" fill={fillColor} />
        <path d="M13 10H5.5V11H13V10Z" fill={fillColor} />
        <path d="M9 6H5.5V7H9V6Z" fill={fillColor} />
      </svg>
    </div>
  )
}

export default DocumentIcon
